import React, { useCallback } from 'react';
import { useForm } from '~/hooks';
import { useValidation } from '~/hooks/useValidation';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import { useSectionLoader } from '../../hooks';
import sectionTypes from '../sectionTypes';
import { DocumentType } from '~/api/document';

/**
 * @typedef AdditionalInfoReviewValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId * 
 * @typedef FormState
 * @property {AdditionalInfoReviewValues} values The current form values
 */

/** @type {AdditionalInfoReviewValues} */

const defaultState = {
    sectionId: 0
};

const validatationSchema = {
    fromSearchPeriod: {},
    throughSearchPeriod: {}
};

const AdditionalInfoReview = ({ titleOpinionId, validate, validationResult }) => {

    const { onLoad: loadSection } = useSectionLoader(sectionTypes.ADDITIONAL_INFO, titleOpinionId);

    const onLoad = useCallback((values) => {
        return loadSection(values);
    }, [titleOpinionId]);

    const {
        /** @type {FormState} */
        state,
        //fieldActions
    } = useForm({
        /** @type {AdditionalInfoReviewValues} */
        initialState: { ...defaultState },
        onLoad,
        debug: true
    });

    let errorSection = false;
    if (validate) {
        if (!state.values.sectionId) {
            errorSection = true;
        } else {
            for (const [key, value] of Object.entries(state.values)) {
                if (key === 'mobileHome' && value === 'Yes') {
                    if (!state.values.includeMobileHomeCoverage ||
                        (state.values.includeMobileHomeCoverage === 'Yes' && (state.values.book === '' || state.values.page === ''))) {
                        errorSection = true;
                        break;
                    }
                }
                if (key === 'constructionInProgress' && value === 'Yes') {
                    if (!state.values.mechanicsLienAgent || (state.values.mechanicsLienAgent === 'Yes' && !state.values.lienAgentName)) {
                        errorSection = true;
                        break;
                    }
                }
                /*
                if(key === 'updateFromPrevious' && value === 'Yes') {
                    if(!state.values.documents || state.values.documents.filter(x=> x.type == DocumentType.PTO_PriorPolicy).length === 0) {
                        errorSection = true;                        
                        break;
                    }
                }   
                */
            }
            if (!Object.prototype.hasOwnProperty.call(state.values, 'fromSearchPeriod') || !Object.prototype.hasOwnProperty.call(state.values, 'throughSearchPeriod')) {
                errorSection = true;
            }
        }
        validationResult(errorSection);
    }

    const additionalDocuments = state.values && state.values.documents ? state.values.documents.filter(x => x.type == DocumentType.PTO_ATTACHMENT).map((entry) => {
        return entry.file.path;
    }) : [];

    const fileNames = state.values && state.values.documents ? state.values.documents.filter(x => x.type == DocumentType.PTO_PriorPolicy).map((entry) => {
        return entry.file.path;
    }) : [];

    const [, invalidFields] = useValidation(state.values, validatationSchema);

    return (

        <div className="ml-2 mr-5">
            {state.values.sectionId === 0 ?
                <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
                :
                <>
                    <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
                    <div className="text-1xl text-blue-60 font-bold mb-3">
                        <div className="display:flex; flex-direction:row;">
                            <div className="z-10 flex flex-row h-full  text-xs font-semibold text-blue-60">
                                <div className="mt-1 mb-2">8. <a href={`/preliminaryopinion/${titleOpinionId}/additionalInfo`}> Additional Information </a> </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-8 gap-y-1 text-xs mb-4">
                        <div className="col-span-8 text-red-600">
                            {errorSection ?
                                <p className="flex flex-row gap-x-2 mb-2"><BsFillExclamationCircleFill />
                                    You have not provided all the required information in this section.</p>
                                : ''
                            }
                        </div>
                        <div className="col-span-3 font-semibold">Is a mobile or manufactured home located on the property ? </div>
                        <div className="col-span-1 flex-end">{state.values.mobileHome !== null && state.values.mobileHome !== '' ? state.values.mobileHome : 'No'}</div>

                        <div className={`col-span-2 font-semibold ${(invalidFields.fromSearchPeriod || invalidFields.throughSearchPeriod) && 'text-red-600'}`}>
                            The Search Period was from
                        </div>
                        <div className="col-span-2 flex-end">{state.values.fromSearchPeriod ? new Date(state.values.fromSearchPeriod).toLocaleDateString() : ''} through {state.values.throughSearchPeriod ? new Date(state.values.throughSearchPeriod).toLocaleDateString() : ''}</div>

                        <div className="col-span-3 font-semibold">Is construction on the property in progress or immediately contemplated or has construction been recently completed ? </div>
                        <div className="col-span-1 flex-end">{state.values.constructionInProgress}</div>

                        <div className="col-span-2 font-semibold">Property Occupied By </div>
                        <div className="col-span-2 flex-end">{state.values.propertyOccupiedBy ? state.values.propertyOccupiedBy.label : ''}</div>

                        <div className="col-span-3 font-semibold">Do you request that the policy include coverage for any mobile or manufactured home as part of the insured land ? </div>
                        <div className="col-span-1 flex-end">{state.values.includeMobileHomeCoverage}</div>

                        <span className="col-span-4" />
                        <div className="col-span-2 font-semibold">Updating from previous title insurance policy?</div>
                        <div className="col-span-2 flex-end">{state.values.updateFromPrevious}</div>

                        <div className="col-span-2 font-semibold">Copy of Prior Title Policy </div>
                        <div className="col-span-2 flex-end">{fileNames.join(', ')}</div>


                        <div className="col-span-3 font-semibold">Has a Mechanical Lien Agent been appointed ? </div>
                        <div className="col-span-1 flex-end">{state.values.mechanicsLienAgent}</div>

                        <div className="col-span-2 font-semibold">Lien Agent Name</div>
                        <div className="col-span-2 flex-end">{state.values.lienAgentName}</div>

                        <div className="col-span-3 font-semibold">Additional Information</div>
                        <div className="col-span-1 flex-end">{state.values.additionalInformation}</div>

                        <div className="col-span-2 font-semibold">Additional Documents Uploaded</div>
                        <div className="col-span-2 flex-end">{additionalDocuments.join(', ')}</div>

                    </div>
                    <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
                </>
            }
        </div>
    );
};

export default AdditionalInfoReview;